module.exports = __webpack_public_path__ + "static/media/9.8c12f93c.jpg";